import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninComponent } from './pages/signin/signin.component';
import { LoginRoutingModule } from './login-routing.module';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SigninLeftPanelComponent } from './components/signin-left-panel/signin-left-panel.component';
import { GenericRightPanelComponent } from './components/generic-right-panel/generic-right-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibraryModule } from "../../library/library.module";
import { TwofaSplashComponent } from './components/twofa-setup/twofa-splash/twofa-splash.component';
import { EmailOtpSectionComponent } from './components/twofa-setup/email-otp-section/email-otp-section.component';
import { QrScannerSectionComponent } from './components/twofa-setup/qr-scanner-section/qr-scanner-section.component';
import { TwofaTotpSectionComponent } from './components/twofa-setup/twofa-totp-section/twofa-totp-section.component';
import { TwofaTotpVerificationComponent } from './components/twofa-setup/twofa-totp-verification/twofa-totp-verification.component';
import { TwofaSucessSectionComponent } from './components/twofa-setup/twofa-sucess-section/twofa-sucess-section.component';
import { QrCodeModule } from 'ng-qrcode';
import { ResetPasswordEmailSectionComponent } from './components/forget-password-setup/reset-password-email-section/reset-password-email-section.component';
import { ResetCodeSectionComponent } from './components/forget-password-setup/reset-code-section/reset-code-section.component';
import { NewPasswordSectionComponent } from './components/forget-password-setup/new-password-section/new-password-section.component';
import { PasswordSuccessfulSectionComponent } from './components/forget-password-setup/password-successful-section/password-successful-section.component';



@NgModule({
  declarations: [
    SigninComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    SigninLeftPanelComponent,
    GenericRightPanelComponent,
    TwofaSplashComponent,
    EmailOtpSectionComponent,
    QrScannerSectionComponent,
    TwofaTotpSectionComponent,
    TwofaTotpVerificationComponent,
    TwofaSucessSectionComponent,
    ResetPasswordEmailSectionComponent,
    ResetCodeSectionComponent,
    NewPasswordSectionComponent,
    PasswordSuccessfulSectionComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LibraryModule,
    QrCodeModule
  ]
})
export class LoginModule { }
